
export const createMobileNav = async (insertSearch,insertStrefaKlienta) => {
    
    var originalElement = document.querySelector('.navbar > .container');
    var clonedElement = originalElement.cloneNode(true);

    clonedElement.querySelector(".navbar__logo-link").remove();
    document.querySelector(".navbar-mobile ").appendChild(clonedElement);

    
    await insertSearch(".navbar-mobile .navbar__right");
    await insertStrefaKlienta(".navbar-mobile .navbar__right");

 }
 